import React, {useEffect} from 'react';
import M from 'materialize-css';
import { WavyLink } from "react-wavy-transitions";

import carrusel1 from '../Images/Index/Carrusel/1.png';
import carrusel2 from '../Images/Index/Carrusel/2.png';
import carrusel3 from '../Images/Index/Carrusel/3.png';
import carrusel4 from '../Images/Index/Carrusel/4.png';
import carrusel5 from '../Images/Index/Carrusel/5.png';
import carrusel6 from '../Images/Index/Carrusel/6.png';
import carrusel7 from '../Images/Index/Carrusel/7.png';
import carrusel8 from '../Images/Index/Carrusel/8.png';

import carrusel9 from '../Images/Index/Carrusel/9.png';
import carrusel10 from '../Images/Index/Carrusel/10.png';
import carrusel11 from '../Images/Index/Carrusel/11.png';
import carrusel12 from '../Images/Index/Carrusel/12.png';
import carrusel13 from '../Images/Index/Carrusel/13.png';
import carrusel14 from '../Images/Index/Carrusel/14.png';
import carrusel15 from '../Images/Index/Carrusel/15.png';

import behance from '../Images/behance.png';

import { useAuth } from '../Context/Context';


const Portafolio = () => {
  const { direction, cambio } = useAuth();
    
  useEffect(() => {
    var elems = document.querySelectorAll('.sidenav');
    M.Sidenav.init(elems);
  });


    return (
      <div style={{background:"#F8F8F8"}}>

        <div className='container contendor-texto-tablet-1'>
          <p className='sub_titulo_nv_4' style={{color:"#1E1E1E", margin:"0", paddingTop:"65px", lineHeight:"30px", textAlign:"center"}}>
            Dale un vistazo a <br />
            <span style={{color:"#A741AF", fontFamily:"Gotham-Regular"}}>
              nuestro portafolio
            </span>
          </p>
          <p style={{textAlign:"center"}}>
            Conoce algunos de nuestros trabajos <br/>
            para increíbles clientes nacionales e internacionales.
          </p>
        </div>
        
        <div style={{display:"flex", justifyContent:"center", flexWrap:"wrap", marginBottom:"30px"}}>
          <div className='flexbox-boton'>
            <WavyLink direction={direction ? "up" : "down"} to="/portafolio" color={direction ? "#BF1F60" : "#2A79B0"}>
              <p class="btn_2" onClick={cambio} style={{width:"220px", color:"#fff"}}>
                Ver portafolio
              </p>
            </WavyLink>
            {/* <a href="/portafolio" style={{color:"#fff"}}>
              <div className='btn_2'>
                Ver portafolio
              </div>
            </a> */}
            <a target="_blank" rel="noopener noreferrer" href="https://www.behance.net/softwareover1" style={{color:"#fff"}}>
              <div className='btn_2 margin-movil-1' style={{backgroundColor:"#134263"}}>
                  <img src={behance} alt="Behance" className='imagen_be' />
              </div>
            </a>
          </div>
        </div>

        <section class="slide-option">
          <div id="infinite" class="highway-slider">
            <div class="highway-barrier">
              <ul class="highway-lane">
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel1}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel2}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel3}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel4}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel5}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel6}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel7}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel8}></img></li>

                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel1}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel2}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel3}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel4}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel5}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel6}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel7}></img></li>
                <li class="highway-car"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel8}></img></li>
              </ul>
            </div>
          </div>
        </section>

        <section class="slide-option" style={{paddingBottom:"20px"}}>
          <div id="infinite" class="highway-slider">
            <div class="highway-barrier">
              <ul class="highway-lane efectro-right top-chico-portafolio" style={{position:"relative"}}>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel9}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel10}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel11}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel12}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel13}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel8}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel14}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel15}></img></li>

                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel9}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel10}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel11}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel12}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel13}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel8}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel14}></img></li>
                <li class="highway-car-2"><img alt="" style={{width:"100%", borderRadius:"15px"}} src={carrusel15}></img></li>
              </ul>
            </div>
          </div>
        </section>

      </div>
    );
}

export default Portafolio;
